<div class="container-fluid">
  <div class="row section1 align-items-center">
    <div class="col">
      <div class="home-details">
        <h5 class="home-title">Category</h5>
        <p class="home-subtitle">Details of category</p>
      </div>
    </div>
    <div class="col-auto">
      <div class="dashboard-btn dashboard-manage">
        <button class="btn btn-primary btn-dashboard" (click)="helper.goBack()">Back</button>
        <a [routerLink]="['/categories/edit-category/', categoryId]">
          <button class="btn btn-primary btn-dashboard">Edit Details</button>
        </a>
      </div>
    </div>
  </div>
  <div class="row section1">
    <div class="col-6 border-right ">
      <div class="applicants-details details1 pt-4">
        <div class="row align-items-center justify-content-between pb-2">
          <div class="col single-user"><p>Category Icon</p></div>
          <div class="col-auto">
            <img src="{{category.icon}}" alt="" width="100">
          </div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Category Name</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{category.categoryName}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>ID</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{category.id}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Created At</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            <p>{{category.createdAt | date: 'medium'}}</p>
          </div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Updated At</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
            <p>{{category.updatedAt | date: 'medium'}}</p>
          </div>
        </div>
        <hr class="border2">
      </div>
    </div>
    <div class="col-6">
      <div class="applicants-details details1 pt-4 mb-3 pb-0">
        <h6 class="job-title">Informative Parameters</h6>
        <hr class="border2">
        @for (ifs of infoFields; track ifs) {
          <div style="color: orange">
            <h6 class="job-title subtitle">{{ifs.fieldName}}</h6>
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                <p>Field Type</p>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                <p>{{ifs.fieldType}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
                <p>Field Required</p>
              </div>
              <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
                <p>{{ifs.isRequired ? 'Yes' : 'No'}}</p>
              </div>
            </div>
            <hr class="border2">
          </div>
        }
      </div>
      @if (!!subFields?.length) {
        <div class="applicants-details details1 pt-4 mb-3 pb-0">
          <h6 class="job-title">Subjective Parameters</h6>
          <hr class="border2">
          @for (sf of subFields; track sf) {
            <div style="color: orange">
              <h6 class="job-title subtitle">{{sf.fieldName}}</h6>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
